import { BookDemoTooltip } from '@linearb/linui-common';
import { mapCustomComponents } from './CustomComponents';
import { Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import { SPACES } from 'common/constants/sizes';

const StyledCustomComponentFilter = styled(Padding)`
  padding-bottom: ${SPACES.small};
  padding-top: ${SPACES.small};
`;

const CustomFilterWithCTA = ({
  type,
  customComponentProps = {},
  ctaButtonText = '',
  ctaMessage = '',
  navigateBookDemoClick
}) => {
  const bookDemoTooltipProps = {
    message: ctaMessage,
    buttonText: ctaButtonText,
    disabled: false,
    onClick: navigateBookDemoClick
  };

  const CustomComponent = mapCustomComponents[type];
  return (
    <BookDemoTooltip {...bookDemoTooltipProps}>
      <StyledCustomComponentFilter data-testid='custom-component-filter-test-id'>
        {CustomComponent && CustomComponent({ customComponentProps })}
      </StyledCustomComponentFilter>
    </BookDemoTooltip>
  );
};

export default CustomFilterWithCTA;
